import { useTranslation } from 'react-i18next';
import { ProductImage } from '@/lib/images';

// Distributor banners (1672×941, text baked in). The first one spans the full
// width; the rest sit two per row from md up. Each opens full size so the
// small print stays readable on phones.
const BANNERS = [
  { key: 'couple', src: '/products/bears-banner-couple.webp' },
  { key: 'ingredients', src: '/products/bears-banner-ingredients.webp' },
  { key: 'chocolateHoney', src: '/products/bears-banner-chocolate-honey.webp' },
  { key: 'benefits', src: '/products/bears-banner-benefits.webp' },
  { key: 'confidence', src: '/products/bears-banner-confidence.webp' },
];

export const BearsShowcase = () => {
  const { t } = useTranslation();

  return (
    <section aria-labelledby="showcase-title" className="mx-auto max-w-content px-4 py-10 md:px-6 md:py-[60px]" data-testid="bears-showcase-section">
      <h2 id="showcase-title" className="text-center font-heading text-[clamp(32px,3.6vw,48px)] font-extrabold leading-none tracking-[-0.035em]">
        {t('showcase.title')}
      </h2>
      <p className="mx-auto mt-2.5 max-w-[640px] text-center text-candy-ink-muted">{t('showcase.subtitle')}</p>

      <ul className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-5">
        {BANNERS.map((b, i) => (
          <li key={b.key} className={i === 0 ? 'md:col-span-2' : ''}>
            <a
              href={b.src}
              target="_blank"
              rel="noopener"
              aria-label={`${t(`showcase.alt.${b.key}`)} — ${t('showcase.open')}`}
              className="group block overflow-hidden rounded-card bg-candy-surface shadow-[0_18px_40px_-24px_rgb(var(--ink)/0.35)]"
              data-testid={`showcase-${b.key}`}
            >
              <ProductImage
                src={b.src}
                alt={t(`showcase.alt.${b.key}`)}
                sizes={i === 0 ? '(min-width: 1280px) 1232px, 100vw' : '(min-width: 1280px) 606px, (min-width: 768px) 50vw, 100vw'}
                width="1672"
                height="941"
                className="aspect-[1672/941] h-auto w-full object-cover transition-transform duration-300 ease-out motion-safe:group-hover:scale-[1.02]"
              />
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};
